import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToReframeProblems');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">Further Information</span>
                                            </div>

                                            <div className="paraspace"><p>If you found this tool useful then
                                                you are likely to find the following tools both insightful
                                                and relevant: </p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBeInnovative')}>How
                                                        to be innovative </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}>How
                                                        to think about problems laterally</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}>How
                                                        to prioritise tasks ready for action </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}>How
                                                        to focus on the bigger picture </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeComplexIdeasSimpleClearAndConcise')}>How
                                                        to make complex ideas simple, clear and concise </div>
                                                    </li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToCopeWithSetbacks')}>How
                                                        to cope with setbacks </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToUseOptimismToAchieve')}>How
                                                        to use optimism to achieve. </div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad sept"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Myers, D.
                                                    (2003).<span
                                                        className="subtiltereg">  Psychology in Modules,</span> (7th
                                                    ed.) New York: Worth.</p></li>
                                                <li><p className="further_info_content">Allan, D., Kingdon,
                                                    M., Murrin, K. &amp; Rudkin, D (2002) Sticky
                                                    Wisdom.<span className="subtiltereg"> How to Start a Creative Revolution at Work.</span> A
                                                    book from the? What If! creative agency.</p></li>
                                                <li><p className="further_info_content">Barez-Brown, C.
                                                    (2006).<span
                                                        className="subtiltereg"> How to Have Kick-Ass Ideas.</span> Harper
                                                    Element.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}